var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { formatDuration, getTimeIntervalStr, isUndroppable } from '@amzn/atoz-shiftapp-utilities';
import { useAddShiftWrapper } from '../../../hooks';
import { OpportunityFlowModalContentTypes } from '../OpportunityFlowModalFeature/OpportunityFlowModalTypes';
import { gql } from '@apollo/client';
export var useAddOpportunityModalContentData = function (_a) {
    var setModalContent = _a.setModalContent, shiftOpportunity = _a.shiftOpportunity, setModalError = _a.setModalError, onAddShiftConfirmationAnalytics = _a.onAddShiftConfirmationAnalytics;
    var t = useTranslation().t;
    var shift = shiftOpportunity.shift, dropDeadline = shiftOpportunity.dropDeadline;
    var _b = useAddShiftWrapper({
        shiftOpportunity: shiftOpportunity,
        onError: function (error) {
            setModalError(error);
            setModalContent(OpportunityFlowModalContentTypes.error);
        },
        onCompleted: function () {
            setModalContent(OpportunityFlowModalContentTypes.success);
        }
    }), onAddShift = _b.onAddShift, loading = _b.loading;
    var onAddShiftOpportunity = function () {
        onAddShiftConfirmationAnalytics();
        onAddShift();
    };
    var modalTitle = '', modalText = '', modalBannerText = '';
    // If "no drop" case, return early
    if (isUndroppable(dropDeadline)) {
        modalTitle = t('shift_management_features_AddOpportunityModalContent_noDropTitle');
        modalText = t('shift_management_features_AddOpportunityModalContent_noDropText');
        modalBannerText = t('shift_management_features_ShiftDetailsModal_isUndroppable');
    }
    else {
        var timeRange = shift.timeRange;
        var startTime = DateTime.fromISO(timeRange.start);
        var endTime = DateTime.fromISO(timeRange.end);
        var shiftDay = startTime.weekdayLong;
        var shiftDate = startTime.toLocaleString({
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
        var intervalStr = getTimeIntervalStr(startTime, endTime);
        var durationStr = formatDuration(endTime.diff(startTime, ['hours', 'minutes', 'seconds']), true);
        modalTitle = t('shift_management_features_AddOpportunityModalContent_dropPenaltyTitle');
        modalText = t('shift_management_features_AddOpportunityModalContent_dropPenaltyText', {
            shiftDay: shiftDay,
            shiftDate: shiftDate,
            intervalStr: intervalStr,
            durationStr: durationStr
        });
        modalBannerText = t('shift_management_features_ShiftDetailsModal_hasDropPenalty');
    }
    return {
        modalTitle: modalTitle,
        modalText: modalText,
        modalBannerText: modalBannerText,
        onAddShiftOpportunity: onAddShiftOpportunity,
        isLoadingAddShiftOpportunity: loading
    };
};
useAddOpportunityModalContentData.fragments = {
    shiftOpportunity: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment UseAddOpportunityModalContentData_ShiftOpportunity on ShiftOpportunity {\n            id\n            type\n            dropDeadline\n            penaltyStartTime\n            shift {\n                id\n                timeRange {\n                    start\n                    end\n                }\n            }\n            incentivePay {\n                payModifiers {\n                    applicableNetAmount {\n                        amount\n                        code\n                    }\n                    category\n                    hourlyAdditionalCompensation {\n                        amount\n                        code\n                    }\n                    name\n                    timeRange {\n                        start\n                        end\n                    }\n                }\n            }\n            eligibility {\n                isEligible\n            }\n        }\n    "], ["\n        fragment UseAddOpportunityModalContentData_ShiftOpportunity on ShiftOpportunity {\n            id\n            type\n            dropDeadline\n            penaltyStartTime\n            shift {\n                id\n                timeRange {\n                    start\n                    end\n                }\n            }\n            incentivePay {\n                payModifiers {\n                    applicableNetAmount {\n                        amount\n                        code\n                    }\n                    category\n                    hourlyAdditionalCompensation {\n                        amount\n                        code\n                    }\n                    name\n                    timeRange {\n                        start\n                        end\n                    }\n                }\n            }\n            eligibility {\n                isEligible\n            }\n        }\n    "])))
};
var templateObject_1;
